import Base from '../../../js/_base';
import bootstrapBreakpoints from '../../../plugins/grid';
import {keyCodes} from '../../../js/_utlis';

export default class Header extends Base {
    get selectors() {
        return {
            quickSearchTrigger: '.quick-search__trigger',
            quickSearchLinks: '.quick-search__links',
            quickSearchInput: '.quick-search__input',
            navBar: '.navbar-nav',
            navBarContainer: '.navbar',
            navBrand: '.navbar-brand',
            search: '.nav-item--quick-search',
            mainMenu: '.main-menu',
            DROPDOWN: '.navbar-nav .nav-item:not(.nav-item--quick-search) .dropdown',
            DROPDOWN_TOGGLE: '[data-toggle="dropdown"]',
        };
    }

    get classList() {
        return {
            NAV_FIXED: ['navbar-light'],
            NAV_NON_FIXED: ['navbar-dark'],
            NAV_LIGHT: 'navbar-light',
            NAV_DARK: 'navbar-dark',
            HEADER_HERO: 'main-header--hero',
            BG_LIGHT: 'bg-white',
            NAV_EXPANDED: 'navbar-expanded',
            FIXED: 'fixed',
            FIXED_VISIBLE: 'fixed--visible',
            FIXED_ANIMATED: 'fixed--animated',
            SEARCH_UP: 'search-move-up',
            SEARCH_ACTIVE: 'search-active',
            SEARCH_PRE_ACTIVE: 'search-pre-active',
            SEARCH_POST_ACTIVE: 'search-post-active',
            BEFORE_NAV_EXPANDED: 'before-navbar-expanded',
            HIDE_NAV_BEFORE_EXPANDED: 'hide-before-navbar-expanded',
        };
    }

    get animationDuration() {
        return 500;
    }

    constructor(headerElement, options = {fixHeaderOnScrollUp: true}) {
        super();
        this.$document = $(document);
        this.setElements(headerElement);
        this._animationDuration = this.animationDuration;
        this.enableUpwardsFixedHeader = options.fixHeaderOnScrollUp;
        this.initialize();
    }

    initialize() {
        if (this._elements.search && this._elements.navBar && this._elements.navBarContainer) {
            this.manageMenuSearchRelation();
        }

        if (this._elements.mainMenu) {
            this.responsiveMenuControl();
        }

        let dropdowns = document.querySelectorAll(this._selectors.DROPDOWN);
        if (dropdowns.length) {
            if (window.innerWidth > bootstrapBreakpoints.xl) {
                this.initDropdowns(dropdowns);
            }
            this.$document
                .on('screen-xl-off', e => {
                    this.initDropdowns(dropdowns);
                })
                .on('screen-xl-on', e => {
                    this.destroyDropdowns(dropdowns);
                });
        }

        if (this._elements.quickSearchInput && this._elements.quickSearchLinks) {
            if (window.innerWidth < bootstrapBreakpoints.xl) {
                this.initQuickSearchLinks();
            }
            this.$document
                .on('screen-xl-off', e => {
                    this.destroyQuickSearchLinks();
                })
                .on('screen-xl-on', e => {
                    this.initQuickSearchLinks();
                });
        }
    }

    setElements(headerElement) {
        this._elements = {
            headerElement,
            trigger: document.querySelector(this._selectors.quickSearchTrigger),
            navBar: headerElement.querySelector(this._selectors.navBar),
            mainMenu: headerElement.querySelector(this._selectors.mainMenu),
            navBarContainer: headerElement.querySelector(this._selectors.navBarContainer),
            navBrand: headerElement.querySelector(this._selectors.navBrand),
            search: null,
            quickSearchInput: headerElement.querySelector(this._selectors.quickSearchInput),
            quickSearchLinks: $(this._selectors.quickSearchLinks),
        };

        if (this._elements.navBar) {
            this._elements.search = this._elements.navBar.querySelector(this._selectors.search);
        }
    }

    responsiveMenuControl() {
        const fixedHeaderControl = this.enableUpwardsFixedHeader ? this.upwardsFixedHeader() : null;
        const $mainMenu = $(this._elements.mainMenu);
        if (fixedHeaderControl) {
            window.addEventListener('scroll', fixedHeaderControl, {passive: true});
        }
        this.$document.on('screen-xl-on screen-xl-off', e => {
            if (e.type === 'screen-xl-on') {
                this.removeFixedControl(); // has to be earlier than heroOnViewportChange or anything that operates with navbar classes on viewport change
                window.removeEventListener('scroll', fixedHeaderControl);
                $mainMenu.on('show.bs.collapse hidden.bs.collapse', e => {
                    if ($mainMenu[0] === e.target) {
                        this.responsiveLogoSwitch(e);
                        const action = e.type === 'show' ? 'add' : 'remove';
                        this._elements.navBarContainer.classList[action](this._classList.NAV_EXPANDED);
                    }
                });
                if (this._elements.search.classList.contains('search-active')) {
                    this._elements.trigger.click();
                }
            }

            if (e.type === 'screen-xl-off') {
                window.addEventListener('scroll', fixedHeaderControl, {passive: true});
                $mainMenu.one('hide', () => {
                    $mainMenu.off('show.bs.collapse hidden.bs.collapse hide.bs.collapse');
                });
                $mainMenu.collapse('hide');
            }

            this.heroOnViewportChange(e.type);
        });
    }

    responsiveLogoSwitch(collapseEvent) {
        const {navBrand} = this._elements;
        if (!navBrand) {
            return;
        }
        const onTransitionEnd = e => {
            if (e.target === e.currentTarget && e.propertyName === 'transform') {
                navBrand.classList[collapseEvent.type === 'show' ? 'add' : 'remove'](
                    this._classList.BEFORE_NAV_EXPANDED
                );
                navBrand.classList.remove(this._classList.HIDE_NAV_BEFORE_EXPANDED);
                navBrand.removeEventListener('transitionend', onTransitionEnd);
            }
        };
        if (
            navBrand.classList.contains('switch-on-expand') &&
            (collapseEvent.type === 'show' || collapseEvent.type === 'hidden')
        ) {
            navBrand.addEventListener('transitionend', onTransitionEnd);
            navBrand.classList.add(this._classList.HIDE_NAV_BEFORE_EXPANDED);
        }
    }

    heroOnViewportChange(type) {
        const {headerElement, navBarContainer} = this._elements;
        if (headerElement.classList.contains(this._classList.HEADER_HERO)) {
            if (type === 'screen-xl-on') {
                navBarContainer.classList.add(this._classList.NAV_LIGHT);
                navBarContainer.classList.remove(this._classList.NAV_DARK);
            } else {
                navBarContainer.classList.remove(this._classList.NAV_LIGHT);
                navBarContainer.classList.add(this._classList.NAV_DARK);
            }
        }
    }

    manageMenuSearchRelation() {
        const {headerElement, trigger, navBar, search, quickSearchInput} = this._elements;
        let expanded = false;
        const duration = this._animationDuration;

        const assignTransition = (element, which, menuChildrenCount, onFinish, initialDelay) => {
            setTimeout(() => {
                const nextTarget = element[`${which}ElementSibling`];
                if (nextTarget) {
                    assignTransition(nextTarget, which, menuChildrenCount, onFinish);
                } else if (typeof onFinish === 'function') {
                    element.addEventListener('transitionend', onFinish, {once: true});
                }
                if (!element.contains(trigger)) {
                    element.classList.toggle('search-move-up');
                }
            }, initialDelay || duration / menuChildrenCount);
        };

        if (headerElement && search && trigger && navBar && quickSearchInput) {
            trigger.addEventListener('click', e => {
                e.preventDefault();
                const which = expanded ? 'next' : 'previous';
                search.classList.toggle(this._classList.SEARCH_PRE_ACTIVE);
                setTimeout(() => {
                    assignTransition(
                        expanded ? navBar.firstElementChild : navBar.lastElementChild,
                        which,
                        navBar.children.length,
                        e => {
                            expanded = !expanded;
                            if (expanded) {
                                search.classList.add(this._classList.SEARCH_POST_ACTIVE);
                                quickSearchInput.focus();
                                trigger.setAttribute('aria-expanded', 'true');
                                trigger.setAttribute('aria-label', trigger.dataset?.collapseLabel);
                            } else {
                                search.classList.remove(this._classList.SEARCH_POST_ACTIVE);
                                trigger.setAttribute('aria-expanded', 'false');
                                trigger.setAttribute('aria-label', trigger.dataset?.expandLabel);
                            }
                        },
                        expanded ? duration * 0.6 : 0
                    );

                    setTimeout(
                        () => {
                            search.classList.toggle(this._classList.SEARCH_ACTIVE);
                        },
                        expanded ? 0 : duration * 0.2
                    );
                }, duration * 0.8);
            });
            document.addEventListener('keydown', this.handleEscOnSearch.bind(this));
        }
    }

    removeFixedControl() {
        const s = this._classList;
        const {headerElement, navBarContainer} = this._elements;
        headerElement.classList.remove(s.FIXED_ANIMATED, s.FIXED_VISIBLE, s.FIXED);
        headerElement.parentElement.style.paddingTop = '0px';
        navBarContainer.className = navBarContainer.dataset.preservedClassName;
    }

    upwardsFixedHeader() {
        const {headerElement, navBarContainer} = this._elements;
        const removeFixedControl = this.removeFixedControl.bind(this);
        let prevScrollY = 0;
        const s = this._classList;

        navBarContainer.dataset.preservedClassName = navBarContainer.className;

        return function () {
            const {height} = headerElement.getBoundingClientRect();
            if (window.scrollY > height) {
                if (!headerElement.classList.contains(s.FIXED)) {
                    // checking for class presence for the sake of performance
                    headerElement.classList.add(s.FIXED);
                    headerElement.parentElement.style.paddingTop = height + 'px';
                }
            } else {
                removeFixedControl();
                return;
            }

            if (prevScrollY > window.scrollY) {
                headerElement.classList.add(s.FIXED_ANIMATED, s.FIXED_VISIBLE);
                navBarContainer.classList.add(...s.NAV_FIXED);
                navBarContainer.classList.remove(...s.NAV_NON_FIXED);
            } else {
                headerElement.classList.remove(s.FIXED_VISIBLE);
            }
            prevScrollY = window.scrollY;
        };
    }

    initDropdowns(dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('mouseenter', this.onDropdownOver);
            dropdown.addEventListener('mouseleave', this.onDropdownOut);
        });
    }

    destroyDropdowns(dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.removeEventListener('mouseenter', this.onDropdownOver);
            dropdown.removeEventListener('mouseleave', this.onDropdownOut);
        });
    }

    initQuickSearchLinks() {
        this.quickSearchLinksHandler = this.showQuickSearchLinks.bind(this);
        this._elements.search.addEventListener('click', this.quickSearchLinksHandler, true);
        this._elements.quickSearchInput.addEventListener('focus', this.quickSearchLinksHandler, true);
        this.hideQuickSearchLinks();
    }

    destroyQuickSearchLinks() {
        this._elements.search.removeEventListener('click', this.quickSearchLinksHandler, true);
        this._elements.quickSearchInput.removeEventListener('focus', this.quickSearchLinksHandler, true);
        this.showQuickSearchLinks();
    }

    showQuickSearchLinks() {
        this._elements.quickSearchLinks.collapse('show');
        this._elements.search.removeEventListener('click', this.quickSearchLinksHandler);
        this._elements.quickSearchInput.removeEventListener('focus', this.quickSearchLinksHandler);
    }

    hideQuickSearchLinks() {
        this._elements.quickSearchLinks.collapse('hide');
    }

    handleEscOnSearch(e) {
        const {trigger, search} = this._elements;
        if (
            e.keyCode === keyCodes.ESC &&
            search.classList.contains(this._classList.SEARCH_POST_ACTIVE) &&
            search.classList.contains(this._classList.SEARCH_PRE_ACTIVE)
        ) {
            trigger.click();
            trigger.focus();
        }
    }

    onDropdownOver(e) {
        if (!e.target.classList.contains('show')) {
            const toggler = e.target.children[0];
            $(toggler).dropdown('toggle');
        }
    }
    onDropdownOut(e) {
        if (e.target.classList.contains('show')) {
            const toggler = e.target.children[0];
            $(toggler).dropdown('toggle');
        }
    }
}
